import { useState } from "react"

export const LibraryState = () => {
    const [review, setReview] = useState({
        list: [],
        toggled: false,
    });
    const [artcl, setArtcl] = useState({
        list:[],
        form:{
            toggled: false, 
			submitted: false,
			method: '', 
            inputs: {
                file: {value: null, object: null, name: '', type: '', size: 0, updated: false, stat: false, msg: ''},
                title: {value: '', stat: true, msg: ''},
                description: {value: '', stat: true, msg: ''},
                category: {value: '', stat: true, msg: '', list: []},
                taxType: {value: '', stat: true, msg: '', list: []},
                reference: {value: '', stat: true, msg: ''},
                pname: {value: '', stat: true, msg: ''},
                seriesNum: {value: '', stat: true, msg: ''},
                status: {value: 2, stat: true, msg: ''},
                id: {value: '', stat: true, msg: ''},
                static_series: {value: '', stat: true, msg: ''},
            }
        },
        alert: {
            toggled: false,
            type: '',
            msg: '',
        },
        confirmation: {
            type:'',
            toggled: false,
            method: '',
            submitted: false,
            data: null
        },
        review:{
            toggled: false,
            data: null
        }
    });


    // New 
    // publication
    const [publicationInputs, setPublicationInputs] = useState({
        id:'',
        title: '',
        description: '',
        reference: '',
        type: '',
        category: '',
        source: '',
        status: '',
        attachement: {link: null, size: null, type: null, object: null},
        disableInteract: true,
        isDirty: false
    })

    const [publicationType, setPublicationType] = useState([
        {label: 'All', id: 'all', value: 'all'}, 
        {label: 'Article', id: 3, value: 'article'},
        {label: 'News', id: 1, value: 'news'}, 
        {label: 'Updates', id: 2, value: 'updates'}, 
    ])
    const [publicationStatus, setPublicationStatus] = useState([
        { id: 1, label: "For Review", color: "#42474B", bgcolor: "#F7F8F8" },
		{ id: 2, label: "For Revision", color: "#B38600", bgcolor: "#FFF7D6" },
		{ id: 3, label: "For Approval", color: "#453FBA", bgcolor: "#E3F2FD" },
		{ id: 4, label: "Approved", color: "#22A06B", bgcolor: "#DCFFF1" },
		{ id: 5, label: "Posted", color: "#3EA2F3", bgcolor: "#E3F2FD" },
		{ id: 6, label: "Saved", color: "#00437A", bgcolor: "#E3F2FD" },
		{ id: 7, label: "Disapproved", color: "#B30000", bgcolor: "#FFD6D6" },
    ])
    const [publicationList, setPublicationList] = useState([]);
    const [showSnack, setShowSnack] = useState({toggled: false, msg: ''});

    // Bulletin
    const [bulletinList, setbulletinList] = useState([])

    return {
        artcl : { data: artcl, set: setArtcl},
        review : { data: review, set: setReview},

        // New 
        // publication
        publicationInputs : { data: publicationInputs, set: setPublicationInputs},
        publicationType : { data: publicationType, set: setPublicationType},
        publicationStatus : { data: publicationStatus, set: setPublicationStatus},
        publicationList : { data: publicationList, set: setPublicationList},
        showSnack : { data: showSnack, set: setShowSnack},

        // Bulletin
        bulletinList : { data: bulletinList, set: setbulletinList }

    }
}